<mulo-prologue>
  <mulo-centered-block-layout width="auto">
    <mulo-nav-main-layout
      [navPosition]="media.is('lt-md') ? 'top' : 'left'"
      [navShifted]="media.is('lt-md') ? null : 'out'"
      [navSize]="media.is('lt-md') ? 'auto' : 220"
      >
      <div class="back-btn-wrap" slot="nav">
        <a class="has-icon back-button" mat-button queryParamsHandling="preserve" routerLink="/profile/">
          <mat-icon class="mat-icon-rtl-mirror" svgIcon="chevron-left"></mat-icon>
          {{ 'research.outputClaim.back' | translate }}
        </a>
      </div>
      <div slot="main">
        <h1>{{ 'research.outputClaim.title' | translate: { value: paginationConfig.totalItems } }}</h1>
      </div>
    </mulo-nav-main-layout>
  </mulo-centered-block-layout>
</mulo-prologue>

@if (!noResults) {
  <mulo-centered-block-layout
    [class]="media.is('lt-md') ? 'padding-top-sm padding-bottom-sm' : 'padding-sm'"
    width="auto"
    >
    <p class="infobar">{{ 'research.outputClaim.subtitle' | translate }}</p>
    <div class="action-bar">
      <mat-checkbox
        (change)="handleSelectAllChange($event)"
        [checked]="pageAllSelected"
        [indeterminate]="!pageAllSelected && pageSomeSelected"
        >
        {{
        'research.outputClaim.selectAll'
        | translate: { value1: pageFirstIdx, value2: pageLastIdx, value3: paginationConfig.totalItems }
        }}
      </mat-checkbox>
      <button
        (click)="handleClaimOrReject(true)"
        [disabled]="selectedCount == 0"
        class="has-icon"
        color="primary"
        mat-button
        >
        <mat-icon svgIcon="check"></mat-icon>
        {{ 'research.outputClaim.action.claim' | translate: { value: selectedCount } }}
      </button>
      <button
        (click)="handleClaimOrReject(false)"
        [disabled]="selectedCount == 0"
        class="has-icon"
        color="primary"
        mat-button
        >
        <mat-icon svgIcon="close"></mat-icon>
        {{ 'research.outputClaim.action.reject' | translate: { value: selectedCount } }}
      </button>
      <div class="sort-by-wrap">
        <label>
          <span class="sort-by-label" id="sortByLabel">{{
            'research.results.sortby.title' | translate
          }}</span>
          <mat-form-field class="is-flexible is-inline sort-by-select">
            <mat-select (selectionChange)="changeSort()" [(value)]="sortBy" aria-labelledby="sortByLabel">
              <mat-option value="create_date">{{
                'research.outputClaim.sortBy.DateImported' | translate
              }}</mat-option>
              <mat-option value="asset_publication_year">{{
                'research.outputClaim.sortBy.DatePublished' | translate
              }}</mat-option>
              <mat-option value="asset_title">{{
                'research.outputClaim.sortBy.title' | translate
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </label>
      </div>
    </div>
  </mulo-centered-block-layout>
  <div
    (muloStickyScrolled)="toolbarScrolled = $event"
    (muloStickyStuck)="toolbarStuck = $event"
    @heightInAnimation
    @heightOutAnimation
    [class.is-scrolled]="toolbarScrolled"
    [class.is-stuck]="toolbarStuck"
    class="toolbar"
    muloSticky
    muloStickyOffsetTop="1rem"
    >
    <mulo-floating-toolbar [disabled]="searchInProgress" [shadow]="toolbarStuck || toolbarScrolled">
      <div class="padding-left-sm" slot="toolbar-left">
        <span cdkAriaLive="polite" class="toolbar-text">
          {{
          'research.profiles.search.results.toolbar'
          | translate
          : {
          start: (currentPageStart | number),
          end: (currentPageEnd | number),
          total: (paginationConfig?.totalItems | number)
        }
        }}
      </span>
    </div>
    @if (toolbarStuck) {
      <mulo-floating-toolbar-buttons slot="toolbar-right">
        <mulo-floating-toolbar-separator style="height: 1rem"></mulo-floating-toolbar-separator>
        <button
          (click)="scrollToTop()"
          @widthOutAnimation
                    [@widthInAnimation]="{
                        value: ':enter',
                        params: { startScale: '1' }
                    }"
          [attr.aria-label]="'research.portal.fulldisplay.backToTopButton' | translate"
          class="margin-zero"
          mat-icon-button
          >
          <mat-icon svgIcon="arrow-up"></mat-icon>
        </button>
      </mulo-floating-toolbar-buttons>
    }
  </mulo-floating-toolbar>
</div>
<mulo-centered-block-layout
  [class]="media.is('lt-md') ? 'padding-top-sm padding-bottom-sm' : 'padding-sm'"
  width="auto"
  >
  @if (searchInProgress) {
    <mulo-loading-slate>
      <mulo-spinner [diameter]="60"></mulo-spinner>
    </mulo-loading-slate>
  }
  <div aria-label="Items to be claimed" class="outputs-wrapper" role="group">
    @for (output of outputs | paginate: paginationConfig; track output; let i = $index) {
      <exl-citation-brief
        [authors]="output.creators"
        [class.is-selected]="output.selected"
        [disabled]="searchInProgress"
        [lines]="getLines(output)"
        [title]="output.title"
        [titleHeaderLevel]="3"
        >
        <div slot="pre-brief">
          <mat-checkbox
            [(ngModel)]="output.selected"
            [aria-label]="output.title + ' Select this item to be claimed'"
          ></mat-checkbox>
        </div>
        <div class="pre-title" slot="pre-title">
          <span class="type">{{ output.resourceType | translate }}</span>
          <span class="date">{{
            'research.outputClaim.date' | translate: { value: output.createdDate }
          }}</span>
        </div>
        <div class="actions" slot="actions">
          @if (output.notification?.notifications.length > 0) {
            <button
              (click)="openMessagesDialog(output)"
              [color]="'primary'"
              [matTooltip]="'research.output.list.action.message.list' | translate"
              [attr.aria-label]="'research.output.list.action.message.list' | translate"
              mat-icon-button
              >
              <mat-icon class="mat-icon-rtl-mirror" svgIcon="message-text">
                <span [ngClass]="output.notification?.currNote ? 'message-active' : ''"></span>
              </mat-icon>
            </button>
          }
          <button
            (click)="handleClaimOrReject(true, i, output.taskId)"
            [attr.aria-label]="'Claim this item'"
            mat-icon-button
            >
            <mat-icon muloSvgViewbox svgIcon="check"></mat-icon>
          </button>
          <button
            (click)="handleClaimOrReject(false, i, output.taskId)"
            [attr.aria-label]="'Reject this item'"
            mat-icon-button
            >
            <mat-icon muloSvgViewbox svgIcon="close"></mat-icon>
          </button>
          <button [attr.aria-label]="'More actions'" [matMenuTriggerFor]="menu" mat-icon-button>
            <mat-icon muloSvgViewbox svgIcon="dots-vertical"></mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="view(output)" mat-menu-item>
              <span>{{ 'research.output.list.menu.view' | translate }}</span>
            </button>
            <button (click)="openMessagesDialog(output)" mat-menu-item>
              <span>{{ 'research.output.list.action.message.list' | translate }}</span>
            </button>
          </mat-menu>
        </div>
        <mulo-expandable
          [collapseLabel]="'research.results.description.collapse' | translate"
          [ratio]="media.is('lt-md') ? 3 : 8"
          buttonPosition="right"
          expandLabel="...{{ 'research.results.description.expand' | translate }}"
          >
          <p [innerHTML]="output.description | htmlSanitize" class="output-desc"></p>
        </mulo-expandable>
      </exl-citation-brief>
    }
  </div>
  @if (pagesCount > 1) {
    <div class="pagination-wrap">
      <mulo-floating-toolbar class="margin-top-md">
        <div slot="toolbar-middle">
          <pagination-template
            #p="paginationApi"
            (pageChange)="pageChange($event)"
            [id]="paginationConfig.id"
            >
            <mulo-paging
              [data]="p"
              [directionLinksAsIcons]="media.is('xs')"
              [hideLastPage]="outputs?.length > 0"
              [nextLabel]="'research.search.results.next' | translate"
              [previousLabel]="'research.search.results.previous' | translate"
              [screenReaderJumpLabel]="'research.aria.results.page.jump.button' | translate"
              id="pagination"
            ></mulo-paging>
          </pagination-template>
        </div>
      </mulo-floating-toolbar>
    </div>
  }
</mulo-centered-block-layout>
} @else {
  <mulo-centered-block-layout class="padding-sm" width="auto">
    <div class="no-outputs">
      <img alt="" src="assets/images/no-new-outputs.svg" />
      <p class="no-results-notice">{{ 'research.outputClaim.noOutputs' | translate }}</p>
      <button (click)="backToProfile()" class="is-large" color="primary" mat-button>
        {{ 'research.outputClaim.back' | translate }}
      </button>
    </div>
  </mulo-centered-block-layout>
}


<ng-template #claimDialog let-data>
  <div class="padding-xs">
    @if (data?.selectedCount > 1) {
      <h2 mat-dialog-title>
        {{ 'research.outputClaim.selectAll.claim.dialog.title' | translate: { value: selectedCount } }}
      </h2>
    } @else {
      <h2 mat-dialog-title>{{ 'research.outputClaim.selectOne.claim.dialog.title' | translate }}</h2>
    }

    <mat-dialog-content>
      <mat-checkbox [(ngModel)]="skipClaimDialog">{{
        'research.outputClaim.dialog.checkbox.hide' | translate
      }}</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'research.outputClaim.dialog.cancel' | translate }}</button>
      <button [mat-dialog-close]="true" color="primary" mat-flat-button>
        {{ 'research.outputClaim.dialog.claim' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #rejectDialog let-data>
  <div class="padding-xs">
    @if (data?.selectedCount > 1) {
      <h2 mat-dialog-title>
        {{ 'research.outputClaim.selectAll.reject.dialog.title' | translate: { value: selectedCount } }}
      </h2>
    } @else {
      <h2 mat-dialog-title>{{ 'research.outputClaim.selectOne.reject.dialog.title' | translate }}</h2>
    }
    <mat-dialog-content>
      @if (data?.selectedCount > 1) {
        <p>
          {{ 'research.outputClaim.selectAll.reject.dialog.subtitle' | translate }}
        </p>
      } @else {
        <p>{{ 'research.outputClaim.selectOne.reject.dialog.subtitle' | translate }}</p>
      }
      <p class="margin-top-xs">
        <mat-checkbox [(ngModel)]="skipRejectDialog">{{
          'research.outputClaim.dialog.checkbox.hide' | translate
        }}</mat-checkbox>
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>{{ 'research.outputClaim.dialog.cancel' | translate }}</button>
      <button [mat-dialog-close]="true" color="warn" mat-button>
        {{ 'research.outputClaim.dialog.reject' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #viewDialog let-data>
  <button
    aria-label="{{ 'research.aria.dialog.close.dialog' | translate }}"
    class="esp-view-dialog-close has-shadow"
    mat-mini-fab
    matDialogClose
    >
    <mat-icon svgIcon="close"></mat-icon>
  </button>
  <iframe [src]="data?.permalink | safeUrl" [title]="data.title"></iframe>
</ng-template>
